import http from '../../utils/http'
import Vue from 'vue'

const actions = {
	'NEXT_VALUE' : ({}, attribute) => {
		return http.post(`/config/sequences/${attribute}/next`)
			.then((resp) => {
				return resp.data
			})
			.catch(err => {
				console.log(err)
				Vue.rollbar.error('SEQUENCE', err)
			})
	}
}

export default {
	actions
}
